import React from 'react';
import ComingSoonPage from '../components/ComingSoonPage';
import { useAuth } from '../contexts/AuthContext';

export default function Communaute() {
  const { utilisateur, estConnecte } = useAuth();
  // Any authenticated user already participates in the community — there's
  // nothing to "join" once logged in. Send them to the social feed instead.
  // The community_member role is auto-granted at signup.
  const hasAnyActiveRole =
    !!utilisateur?.user_type || (utilisateur?.roles || []).some((r) => r.active !== false);

  let ctaLink;
  let ctaLabel;
  if (!estConnecte) {
    ctaLink = '/signup';
    ctaLabel = { fr: 'Rejoindre la communauté', en: 'Join the community' };
  } else if (hasAnyActiveRole) {
    ctaLink = '/social';
    ctaLabel = { fr: 'Aller au fil communautaire', en: 'Go to community feed' };
  } else {
    ctaLink = '/my-profile';
    ctaLabel = { fr: 'Activer un rôle', en: 'Activate a role' };
  }

  return (
    <ComingSoonPage
      title={{
        fr: 'Communauté ChasseHunt',
        en: 'ChasseHunt Community',
      }}
      sousTitre={{
        fr: 'Bientôt accessible aux membres',
        en: 'Coming soon to members',
      }}
      description={{
        fr: "Forum, partage d'expériences, événements et photos de saisons. Le rendez-vous des chasseurs québécois, ontariens et canadiens, sur une plateforme dédiée.",
        en: 'Forum, experience sharing, events and season photos. The gathering place for Quebec, Ontario and Canadian hunters on a dedicated platform.',
      }}
      cartes={[
        {
          icon: '💬',
          title: { fr: 'Forum par espèce et région', en: 'Forum by species and region' },
          description: {
            fr: 'Discussions thématiques : techniques, équipement, conseils selon votre type de chasse et votre province.',
            en: 'Themed discussions: techniques, gear, tips for your type of hunting and your province.',
          },
        },
        {
          icon: '📅',
          title: { fr: 'Événements et rassemblements', en: 'Events and gatherings' },
          description: {
            fr: 'Calendrier des salons, journées de tir, formations et rendez-vous chasse au Canada.',
            en: 'Calendar of trade shows, shooting days, training sessions and hunting events in Canada.',
          },
        },
        {
          icon: '📸',
          title: { fr: 'Photos et témoignages', en: 'Photos and testimonials' },
          description: {
            fr: 'Partagez vos saisons, vos plus belles prises et vos histoires de terrain avec une communauté de passionnés.',
            en: 'Share your seasons, your best catches and your field stories with a community of enthusiasts.',
          },
        },
      ]}
      // The full Communauté feature is still pending, but the public
      // harvests gallery already works — surface it as a discoverable
      // entry so visitors who land here don't think the whole page is
      // dead. Stays as a secondary link so the main CTA flow is unchanged.
      liensExtras={[
        {
          label: { fr: 'Voir les captures publiques', en: 'See public harvests' },
          link: '/community-harvests',
        },
      ]}
      cta={{
        label: ctaLabel,
        link: ctaLink,
      }}
    />
  );
}
